import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import { viewReferralDetails,updateReferralStatus,getAllReferrals } from "../../../service/Referral/action";
import ReferralDetails from "./referralDetails";

const mapStateToProps = (state) => ({
    referralList:state.Referral.referralList,
    referralDetails:state.Referral.referralDetails,
    referralApproval:state.Referral.referralApproval,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getAllReferrals,
            viewReferralDetails,
            updateReferralStatus
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ReferralDetails);
